<script lang="ts">
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import {getLocalization, getSanitize} from 'src/core';
    import type {ConfirmationDialogModalModel} from './types';
    import {createAcknowledgeActionResponse} from '../modal-utils';
    import {tick} from 'svelte';
    import KpModalHeaderCloseButton from '../kp-modal/KpModalHeaderCloseButton.svelte';
    import KpModalContent from '../kp-modal/KpModalContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpModalFooterCloseButton from '../kp-modal/KpModalFooterCloseButton.svelte';
    import KpMarkdown from 'shared/components/kp-markdown/KpMarkdown.svelte';

    export let model: ConfirmationDialogModalModel;
    export let modalWindowActions: ModalWindowActions;

    const localize = getLocalization();
    const htmlSanitize = getSanitize();

    let buttonFocused = false;
    tick().then(() => buttonFocused = true)

    const handleSubmit = () => {
        modalWindowActions.submitPromise(Promise.resolve(createAcknowledgeActionResponse()));
    }
</script>

<KpModalContent {modalWindowActions} additionalClasses="confirmation-dialog-modal">
    <svelte:fragment slot="header">
        <KpModalHeaderCloseButton/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        {#if model.markdown}
            <KpMarkdown markdown={model.text} block/>
        {:else}
            <p>
                <strong>{@html htmlSanitize(model.text)}</strong>
            </p>
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpButton buttonStyle="primary"
                  dataQa="confirmation-dialog-submit"
                  focused={buttonFocused}
                  on:click={handleSubmit}>
            {localize(/* @kp-localization commons.ANO */ 'commons.ANO')}
        </KpButton>

        <KpModalFooterCloseButton dataQa="confirmation-dialog-cancel"/>
    </svelte:fragment>
</KpModalContent>